// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"3db86323","194":"677de2ac","670":"7d5cd36b","696":"a28122af","824":"b05b95df"}[chunkId] + ".chunk.js";
};